import { tns } from "tiny-slider";

const initHeader = () => {
	const carousel = document.querySelector(".js-header-carousel");
	const navContainer = document.querySelector(".js-nav-container");
	const controlsContainer = document.querySelector(".js-controller-container");
	if (!carousel) {
		return;
	}

	if (!navContainer) {
		return;
	}

	if (!controlsContainer) {
		return;
	}

	tns({
		items: 1,
		container: carousel,
		mode: "carousel",
		navContainer: navContainer,
		navPosition: "bottom",
		controlsContainer: controlsContainer,
		controlsPosition: "bottom",
		autoplay: false,
		loop: true,
		mouseDrag: true,
		autoplayButtonOutput: false,
		responsive: {
			768: {
				mouseDrag: false,
				autoplay: true,
				autoplayButtonOutput: false,
				speed: 500,
				autoplayHoverPause: true,
			},
		},
		onInit: () => {
			carousel.classList.add("opacity-100");
		},
	});
};

export default initHeader();
